import api from '../../services/api';
import { debounceAsync } from '../../utils/debounce';

const fetchProgramas = async (inputValue = '') => {
  try {
    const nome = typeof inputValue === 'string' ? inputValue.trim() : '';
    const response = await api.get('/programas/', {
      params: {
        nome,
        limit: 20,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data.results.map(p => ({ value: p.id, label: p.nome }));
  } catch (error) {
    console.error('Erro ao carregar programas', error);
    return [];
  }
};

const debouncedFetchProgramas = debounceAsync(fetchProgramas, 500);

const programasService = {
  loadProgramas: debouncedFetchProgramas,
};

export default programasService;
